<div class="simulation-info-page">
  <app-header></app-header>

  <main class="simulation-info-content">
    <!-- Caixa branca com a tabela -->
    <div class="content-box">
      <h2 class="box-title">Período de Recompra</h2>
      <app-leads-table
        [availableOrigins]="availableFilterOrigins"
        [columns]="tableColumns"
        [data]="tableData"
        [filterConfig]="filterConfig"
        [serverSidePagination]="serverSidePagination"
        [loading]="loading"
        [emptyMessage]="emptyMessage"
        [errorMessage]="errorMessage"
        [viewButtonTracking]="{
          trackEvent: 'visualizar_recompra',
          trackCategory: 'recompra',
          trackLabel: 'view_recompra'
        }"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (viewLeadClick)="onViewLead($event)"
        (searchChange)="onSearchChange($event)"
        (filterChange)="onFilterChange($event)"
        (dateRangeChange)="onDateRangeChange($event)"
        (clearAllFilters)="onClearAllFilters()"
        (sortChange)="onSortChange($event)">
      </app-leads-table>
    </div>
  </main>
</div>
